import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';
import { CarStorage } from './carStorage';

export class AdditionalRentalComparisonItem {
    constructor(doc)
    {
		this.label = null;
		this.additionalComparisonLineItemDescription = null;
		this.additionalComparisonLineItemIdentifier = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.additionalComparisonLineItemDescription = x.getStringElement(doc, "./ns:AdditionalComparisonLineItemDescription");
		this.additionalComparisonLineItemIdentifier = x.getStringElement(doc, "./ns:AdditionalComparisonLineItemIdentifier");
   }
}

export class AdditionalRentalComparisonItems {
    constructor(doc)
    {
		this.label = null;
		this.additionalRentalComparisonItem = [];
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:ADDITIONAL_RENTAL_COMPARISON_ITEM/ns:ADDITIONAL_RENTAL_COMPARISON_ITEM");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.additionalRentalComparisonItem.push(new AdditionalRentalComparisonItem(xn));
			});
		}
   }
}

export class RentalComparisonDetail {
    constructor(doc)
    {
		this.label = null;
		this.amenitiesComparisonType = null;
		this.carStoragesComparisonType = null;
		this.comparableWeightType = null;
		this.rentalUnitAdjustedRentAmount = null;
		this.rentalUnitToSubjectComparisonType = null;
		this.siteInfluencesComparisonType = null;
		this.viewsComparisonType = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.amenitiesComparisonType = x.getStringElement(doc, "./ns:AmenitiesComparisonType");
		this.carStoragesComparisonType = x.getStringElement(doc, "./ns:CarStoragesComparisonType");
		this.comparableWeightType = x.getStringElement(doc, "./ns:ComparableWeightType");
		this.rentalUnitAdjustedRentAmount  = x.getMISMOAmountElement(doc, "./ns:RentalUnitAdjustedRentAmount");
		this.rentalUnitToSubjectComparisonType = x.getStringElement(doc, "./ns:RentalUnitToSubjectComparisonType");
		this.siteInfluencesComparisonType = x.getStringElement(doc, "./ns:SiteInfluencesComparisonType");
		this.viewsComparisonType = x.getStringElement(doc, "./ns:ViewsComparisonType");
   }
}

export class RentalComparison {
    constructor(doc)
    {
		this.label = null;
		this.additionalRentalComparisonItems = [];
		this.rentalComparisonDetail = null;
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:ADDITIONAL_RENTAL_COMPARISON_ITEMS/ns:ADDITIONAL_RENTAL_COMPARISON_ITEM");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.additionalRentalComparisonItems.push(new AdditionalRentalComparisonItem(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:RENTAL_COMPARISON_DETAIL");
		if (node !== null)
				this.rentalComparisonDetail = new RentalComparisonDetail(node);
   }
}

export class RentalInformation {
    constructor(doc) {
		this.label = null;
		this.carStorages = [];
		this.rentalComparison = null;
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:CAR_STORAGES/ns:CAR_STORAGE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.carStorages.push(new CarStorage(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:RENTAL_COMPARISON");
		if (node !== null)
				this.rentalComparison = new RentalComparison(node);
   }

	GetVehicleStorageSpaces() {
		let details = "";
		if (this.carStorages.length === 0) return details;

		for (let carStorage of this.carStorages) {
			details = h.addWithNewline(details, carStorage.GetCarStorageType());
			details = h.addWithSpacer(details, carStorage.carStorageDetail.parkingSpacesCount);
		}
		return details;
	}

}

export class AdditionalRentalIncome {
    constructor(doc)
    {
		this.label = null;
		this.additionalRentalIncomeType = null;
		this.additionalRentalIncomeTypeOtherDescription = null;
		this.monthlyActualAdditionalIncomeAmount = null;
		this.monthlyEstimatedAdditionalIncomeAmount = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.additionalRentalIncomeType = x.getStringElement(doc, "./ns:AdditionalRentalIncomeType");
		this.additionalRentalIncomeTypeOtherDescription = x.getStringElement(doc, "./ns:AdditionalRentalIncomeTypeOtherDescription");
		this.monthlyActualAdditionalIncomeAmount  = x.getMISMOAmountElement(doc, "./ns:MonthlyActualAdditionalIncomeAmount");
		this.monthlyEstimatedAdditionalIncomeAmount  = x.getMISMOAmountElement(doc, "./ns:MonthlyEstimatedAdditionalIncomeAmount");
   }

	GetIncomeType() {
		return h.descriptionOrOther(this.additionalRentalIncomeType, this.additionalRentalIncomeTypeOtherDescription);
	}

}

export class AdditionalRentalIncomes {
    constructor(doc)
    {
		this.label = null;
		this.additionalRentalIncome = [];
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:ADDITIONAL_RENTAL_INCOME/ns:ADDITIONAL_RENTAL_INCOME");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.additionalRentalIncome.push(new AdditionalRentalIncome(xn));
			});
		}
   }
}

export class RentalInformationSummaryDetail {
    constructor(doc)
    {
		this.label = null;
		this.propertyRentControlStatusType = null;
		this.rentControlDescription = null;
		this.totalMonthlyActualAdditionalIncomeAmount = null;
		this.totalMonthlyActualIncomeAmount = null;
		this.totalMonthlyActualRentAmount = null;
		this.totalMonthlyActualRentAmountEstimatedIndicator = null;
		this.totalMonthlyEstimatedAdditionalIncomeAmount = null;
		this.totalMonthlyEstimatedIncomeAmount = null;
		this.totalMonthlyMarketRentAmount = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.propertyRentControlStatusType = x.getStringElement(doc, "./ns:PropertyRentControlStatusType");
		this.rentControlDescription = x.getStringElement(doc, "./ns:RentControlDescription");
		this.totalMonthlyActualAdditionalIncomeAmount  = x.getMISMOAmountElement(doc, "./ns:TotalMonthlyActualAdditionalIncomeAmount");
		this.totalMonthlyActualIncomeAmount  = x.getMISMOAmountElement(doc, "./ns:TotalMonthlyActualIncomeAmount");
		this.totalMonthlyActualRentAmount  = x.getMISMOAmountElement(doc, "./ns:TotalMonthlyActualRentAmount");
		this.totalMonthlyActualRentAmountEstimatedIndicator = x.getBooleanElement(doc, "./ns:TotalMonthlyActualRentAmountEstimatedIndicator");
		this.totalMonthlyEstimatedAdditionalIncomeAmount  = x.getMISMOAmountElement(doc, "./ns:TotalMonthlyEstimatedAdditionalIncomeAmount");
		this.totalMonthlyEstimatedIncomeAmount  = x.getMISMOAmountElement(doc, "./ns:TotalMonthlyEstimatedIncomeAmount");
		this.totalMonthlyMarketRentAmount  = x.getMISMOAmountElement(doc, "./ns:TotalMonthlyMarketRentAmount");
   }
}

export class RentalInformationSummary {
    constructor(doc)
    {
		this.label = null;
		this.additionalRentalIncomes = [];
		this.rentalInformationSummaryDetail = null;
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:ADDITIONAL_RENTAL_INCOMES/ns:ADDITIONAL_RENTAL_INCOME");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.additionalRentalIncomes.push(new AdditionalRentalIncome(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:RENTAL_INFORMATION_SUMMARY_DETAIL");
		if (node !== null)
				this.rentalInformationSummaryDetail = new RentalInformationSummaryDetail(node);
   }

	GetActualRent() {
		let rent = (this.rentalInformationSummaryDetail.totalMonthlyActualRentAmountEstimatedIndicator ?? false) ? "~" : "";
		rent += this.rentalInformationSummaryDetail.totalMonthlyActualRentAmount.ToDollarAmount();
		return rent;
	}

}
